module.exports = __webpack_public_path__ + "img/tsuyukusa.38967060.jpg";